import { useContext } from 'react';
import { InboundContext } from '../context/InboundContext';
import { TopHeader, MessageCard } from '../components/common';
import PoweredbySaral from '../assets/images/powered-by-saral.svg';
import styles from '../styles/success.module.css';

export default function Success() {
  const { inboundData, t } = useContext(InboundContext);

  const getBrandWebsiteURL = (link: string | undefined) => {
    if (!link?.includes('http')) return `https://${link}`;
    return link;
  };

  return (
    <div className={styles.successContainer}>
      <TopHeader />
      <div className={styles.successCardContainer}>
        <MessageCard
          emoji={inboundData?.thanksPage?.headline.emoji}
          heading={inboundData?.thanksPage?.headline.txt}
          message={inboundData?.thanksPage?.headline.subTxt}
          buttonText={t('goBackToStoreCta')}
          onClick={() => {
            window.location.href = getBrandWebsiteURL(inboundData?.landingPage?.brandWebsite);
          }}
          buttonColor={inboundData?.thanksPage.colors.btn}
          buttonTextColor={inboundData?.thanksPage.colors.btnText}
          fontStyle={inboundData?.landingPage?.fontStyle}
        />
      </div>
      <a href="https://getsaral.com" target="_blank" rel="noreferrer">
        <img src={PoweredbySaral} alt="powered by Saral" className={styles.poweredBySaral} />
      </a>
    </div>
  );
}
